// Import Swiper and modules
import Swiper from "swiper/bundle";

export const articleMetaobjects = () => {
  const $articleMetaobjects = document.querySelector(".article-metaobjects");
  if ($articleMetaobjects) {
    const $articleMetaobjectsIndex = $articleMetaobjects.querySelector(
      ".article-megaobjects__index"
    );
    if ($articleMetaobjectsIndex) {
      const $indexlist = $articleMetaobjectsIndex.querySelector(".index__list");
      const $indexExpandButton = $articleMetaobjectsIndex.querySelector(
        ".index__expand-button"
      );
      $indexExpandButton?.addEventListener("click", (event) => {
        event.preventDefault();
        if ($indexlist.classList.contains("index__list--active")) {
          $indexlist.classList.remove("index__list--active");
          $indexExpandButton.innerText = "Expand";
        } else {
          $indexlist.classList.add("index__list--active");
          $indexExpandButton.innerText = "Reduce";
        }
      });
    }

    const $articleMetaobjectsContent = $articleMetaobjects.querySelector(
      ".article-metaobjects__content"
    );

    const $metaobjectProductsSections =
      $articleMetaobjectsContent.querySelectorAll(".metaobject__products");
    $metaobjectProductsSections.forEach(($metaobjectProductsSection) => {
      const $swiper = $metaobjectProductsSection.querySelector(
        ".featured-products__products.swiper"
      );
      if ($swiper) {
        const swiperConfig = {
          slidesPerView: 1.2,
          loop: false,
          spaceBetween: 10,
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
          },
        };

        const swiperObject = new Swiper($swiper, swiperConfig);
      }
    });

    const $metaobjectCardSections = $articleMetaobjectsContent.querySelectorAll(
      ".metaobject__product-collection-cards"
    );
    $metaobjectCardSections.forEach(($metaobjectCardSection) => {
      const $swiper = $metaobjectCardSection.querySelector(
        ".product-collection-cards__items.swiper"
      );
      if ($swiper) {
        const swiperConfig = {
          slidesPerView: 1.15,
          loop: false,
          spaceBetween: 12,
        };

        // Swiper's inline slide widths beat the desktop CSS grid, so instead
        // of leaving it running and disabled, fully destroy/rebuild it as the
        // viewport crosses the breakpoint - destroy(true, true) strips the
        // inline styles it applied, leaving plain divs for the grid to size.
        const mobileMediaQuery = window.matchMedia("(max-width: 767px)");
        let swiperObject = null;

        const syncSwiper = (query) => {
          if (query.matches) {
            if (!swiperObject) {
              swiperObject = new Swiper($swiper, swiperConfig);
            }
          } else if (swiperObject) {
            swiperObject.destroy(true, true);
            swiperObject = null;
          }
        };

        syncSwiper(mobileMediaQuery);
        mobileMediaQuery.addEventListener("change", syncSwiper);
      }
    });
  }
};

export default articleMetaobjects;
